import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  BoxGroupImage: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '8px',
  },
  BoxUploadImage: {
    display: 'flex',
    width: '100px',
    height: '100px',
    padding: '25px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    border: '1px dashed var(--Primary-500, #3D9F4A)',
    background: 'var(--Primary-25, #F7FDF8)',
  },
  BoxImage: {
    display: 'flex',
    width: '100px',
    height: '100px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  Icons: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  EditButton: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    gap: '4px',
  },
  Divider: {
    width: '1px',
    height: '20px',
    backgroundColor: 'var(--Gray-300, #E0E0E0)',
  },
}));

export { useStyles };
